import ListSchools from './ListSchools';
export default ListSchools;
